import React, { useState, useEffect } from "react";
import "antd/dist/antd.min.css";
import PageWrapper from "../../helpers/PageWrapper";
import { Input, Form,  message, Space, Button, Typography, DatePicker, Select, Table, Popconfirm  } from "antd";
import moment from "moment";
import TokenService from "../../../services/token.service";
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import authAxios from "../../../services/api";
import { DeleteTwoTone, DownloadOutlined, EditTwoTone } from '@ant-design/icons';

const { Title } = Typography;
const styles = { width: '800px', margin: '0 auto' };

const LessonCreatePage = () => {
  const { teacherId, streamId } = useParams();
  const [theme, setTheme] = useState('');
  const [desc, setDesc] = useState('');
  const [hour, setHour] = useState('');
  const [date, setDate] = useState(new Date());
  const navigate = useNavigate();
  const { Option } = Select;
  const [examsList, setExamsList] = useState([]);

  const UpdateTable = () => {
    authAxios.get(`http://85.159.27.198:8080/abitur/api/v1/final-exam/get-by-streamid/${streamId}`,{

      headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
      }
  })
      .then((response) => {
        setExamsList({
          id:response.data.id,
          hour:response.data.hour,
          theme: response.data.theme,
          desc: response.data.description,
          date: response.data.date
        });
        console.log(examsList)
      })
      .catch((err) => {
        console.log(err.message);
      });
};

  useEffect(() => {
    UpdateTable()
    
    
  }, []);
  
  const dataSource = [
    {
      id: examsList.id,
      hour:examsList.hour,
      theme: examsList.theme,
      date: examsList.date,
      homeWork: examsList.desc,
    },]
  const columns = [
    {
      title: "Дата проведения экзамена",
      dataIndex: "date",
      width: "15%",
      key: "date",
      
    },
    {
      title: "Количество учебных часов",
      dataIndex: "hour",
      editable: true,
    },
    {
      title: "Тема Экзамена",
      dataIndex: "theme",
      editable: true,
    },
    {
      title: "Описание экзамена",
      dataIndex: "homeWork",
      editable: true,
    },
    {
      title: "operation",
      dataIndex: "operation",
      width: "10%",
      key: "theme",
      render: (_, record) =>
      
        <Space size="middle">
          
            <Popconfirm placement="topLeft" title={'Вы действительно хотите удалить этот экзамен?'} onConfirm={() => handleDeleteLesson(record.id)} okText="Yes" cancelText="No">
          <Button className={styles.deleteButton} >
            <DeleteTwoTone twoToneColor="#ff0000"  />
          </Button>
          </Popconfirm>
          
        </Space>
        
    },
  ];

  const onDateChange = (date, dateString) => {
      setDate(dateString)
  };
  const onThemeChange = event => {
      setTheme(event.target.value)
  };
  const onDescChange = event => {
      setDesc(event.target.value)
  };
  const onHourChange = event => {
    setHour(event.target.value)
};



  const handleSubmit = () => {
    const lesson = {
      academicStream: streamId,
      date: date,
      theme: theme,
      desc: desc,
      hour:hour,
    };

    authAxios.post(`http://85.159.27.198:8080/abitur/api/v1/final-exam/create`, lesson, {
      headers: {
        'Authorization': 'Bearer ' + TokenService.getLocalAccessToken()
      }
    })
      .then(res => {
        UpdateTable()
        message.success('Экзамен добавлен', 5);
      })
      .catch((error) =>  message.error(error, 10));
      // navigate(`/lesson-plan-page/teacherId/${teacherId}/stream-id/${streamId}`);
      // window.location.reload();
      
  }

  const handleDeleteLesson = (key) => {
    
    authAxios.delete(`http://85.159.27.198:8080/abitur/api/v1/final-exam/delete/${key}`,{
      method: 'GET',
      headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
      }
  })
      .then(res => {
        UpdateTable()
        message.success('Экзамен удален', 5);
        
      }).catch((error) =>  message.error(error, 10));

      
  };
 

    return (
      <PageWrapper>
        {/* <BackButton onClick = {history.goBack} /> */}
        <Typography.Title level={2}>Создание экзамена</Typography.Title>
        <Form
          layout="vertical"
          size="large"
          style={styles}
          // initialValues={{ remember: true }}
          autoComplete="off"
          onFinish={handleSubmit}
        >
          <Form.Item
            label="Дата экзамена"
            name="date"
            value={date}
            rules={[{ required: true, message: "Выберите дату" }]}
          >
            <DatePicker onChange={onDateChange}
              format="YYYY-MM-DD" showTime={{ defaultValue: moment('00:00:00') }} />
          </Form.Item>

          <Form.Item
            label="Количество учебных часов"
            name="hour"
            value={hour}
            onChange={onHourChange}
            rules={[{ required: true, message: 'Введите количество учебных часов' }]}
          ><Input /></Form.Item>

          <Form.Item
            label="Тема экзамена"
            name="theme"
            value={theme}
            onChange={onThemeChange}
            rules={[{ required: true, message: 'Введите тему экзамена' }]}
          >
             <Input />
          </Form.Item>
          <Form.Item
            label="Описание экзамена"
            name="desc"
            value={desc}
            onChange={onDescChange}
            rules={[
              {
                required: true,
                message: "Введите описание экзамена",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                Сохранить
              </Button>
            </Space>
          </Form.Item>
        </Form>
        
        <Table
        id="table-to-xls"
        rowClassName={() => 'editable-row'}
        bordered
        dataSource={dataSource}
        columns={columns}
      />
      
      </PageWrapper>
    );
  }
export default LessonCreatePage;

